module.exports = __webpack_public_path__ + "img/Osterfeuer-brennt.32109ffa.jpg";